import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useFileManager } from "../context/FileMangerContextHelper";
import { Table } from "flowbite-react";
import { HashLoader } from "react-spinners";
import { Dropdown } from "flowbite-react";
import { IoAddCircleOutline } from "react-icons/io5";
import { BsFiletypePdf } from "react-icons/bs";
import UploadFileModal from "../components/UploadFileModal";
import { useModal } from "../context/ModalContextHelper";

const FolderFilesPage = () => {
  const { title, folderId } = useParams();
  const { folders, folderFiles, getFolderFiles, getUserFolders } =
    useFileManager();
  const [loading, setLoading] = useState(false);
  const [refreshFiles, setRefreshFiles] = useState(false);
  const { setOpenModalFileUpload, openModalFileUpload } = useModal();

  useEffect(() => {
    setLoading(true);
    getFolderFiles(folderId, setLoading).finally(() => {
      setRefreshFiles(false);
    });
  }, [getFolderFiles,refreshFiles]);

  useEffect(() => {
    getUserFolders();
  }, []);

  const formatDate = (isoString) => {
    const date = new Date(isoString);
    return date.toLocaleString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  };

  if (loading)
    return (
      <div className="flex flex-row justify-center items-center h-full w-full">
        <HashLoader
          size={"128px"}
          color="#20396F"
          loading={loading}
          speedMultiplier={2}
        />
      </div>
    );

  return (
    <div className="h-full flex flex-col justify-start border border-gray-200 rounded-md p-4">
      <div className="w-full mb-2 flex flex-row justify-between">
        <div className="flex items-center">
          <Dropdown
            placement="right-end"
            renderTrigger={() => (
              <button className="rounded-md bg-[#003464] px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-[#c96b1a] flex flex-row justify-between items-center mr-4 hover:shadow-lg">
                <IoAddCircleOutline size={20} color="#FFF" title="Upload" />
                <span className="hidden pl-2 md:block">Upload</span>
              </button>
            )}
          >
            <Dropdown.Item
              icon={BsFiletypePdf}
              theme={{ icon: "white mr-1" }}
              onClick={() => {
                setOpenModalFileUpload("dismissible");
              }}
            >
              File
            </Dropdown.Item>
          </Dropdown>
          <UploadFileModal
            openModal={openModalFileUpload}
            setOpenModal={setOpenModalFileUpload}
            folders={folders}
            view={"folder-view"}
            folderTitle={title}
            setRefreshFiles={setRefreshFiles}
          />
        </div>
        <div className="text-2xl font-bold tracking-tight text-gray-900 py-2">
          {title}
        </div>
        <form className="w-1/5">
          <label
            htmlFor="default-search"
            className="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white"
          >
            Search
          </label>
          <div className="relative">
            <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
              <svg
                className="w-4 h-4 text-gray-500 dark:text-gray-400"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 20 20"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                />
              </svg>
            </div>
            <input
              type="search"
              id="default-search"
              className="block w-full px-3 py-3 pl-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-[#003464] focus:border-[#003464]"
              placeholder="Search"
              required
            />
          </div>
        </form>
      </div>
      <div className="overflow-x-auto overflow-y-auto h-full">
        <Table
          hoverable
          theme={{
            root: {
              base: "w-full text-left text-sm text-gray-500 dark:text-gray-400",
              shadow:
                "absolute bg-white dark:bg-black w-full h-full top-0 left-0 rounded-lg -z-10 border border-gray-200",
            },
          }}
        >
          <Table.Head>
            <Table.HeadCell>File Name</Table.HeadCell>
            <Table.HeadCell>File Type</Table.HeadCell>
            <Table.HeadCell>File Size</Table.HeadCell>
            <Table.HeadCell>Date Uploaded</Table.HeadCell>
            <Table.HeadCell>
              <span className="sr-only">Open</span>
            </Table.HeadCell>
          </Table.Head>
          <Table.Body className="divide-y">
            {folderFiles.map((file) => {
              return (
                <Table.Row key={file.id} className="bg-white">
                  <Table.Cell className="whitespace-nowrap font-medium text-gray-900 dark:text-white">
                    {file.file_name}
                  </Table.Cell>
                  <Table.Cell>{file.file_type}</Table.Cell>
                  <Table.Cell>{file.file_size}</Table.Cell>
                  <Table.Cell className="whitespace-nowrap font-medium text-gray-900 dark:text-white">
                    {formatDate(file.uploaded_at)}
                  </Table.Cell>
                  <Table.Cell>
                    <a
                      href={file.file}
                      target="_blank"
                      className="font-medium text-cyan-600 hover:underline dark:text-cyan-500"
                    >
                      Open
                    </a>
                  </Table.Cell>
                </Table.Row>
              );
            })}
          </Table.Body>
        </Table>
      </div>
    </div>
  );
};

export default FolderFilesPage;
